export class ServerError extends Error {
  constructor(message: string = 'Server unavailable', public statusCode?: number, public code?: string) {
    super(message);
  }

  static ServerUnavailableError() {
    return new ServerError('Server unavailable', 0, 'SERVER_UNAVAILABLE');
  }
}
